<div class="ibox" *ngIf="selectedPod">
    <div class="document-header ibox-title">
        <div class="document-column flex-auto">
            <h2>
                <span>
                    <a class="badge badge-link badge-size-h2 cmaweb-link" [href]="link.goToLoadManagementForLoad(selectedPod.loadNumber)" target="_blank">{{selectedPod.loadNumber}}</a>&nbsp;
                    <a class="cmaweb-link" [href]="selectedPod.deliveryNumber" target="_blank">{{selectedPod.deliveryNumber}}</a>
                </span>
            </h2>
        </div>
        <div class="document-column">
            <app-pods-validation-document-source [source]="selectedPod.documentSource"></app-pods-validation-document-source>
        </div>
        <div class="document-column">
            <app-pods-validation-state [state]="selectedPod.state"></app-pods-validation-state>
        </div>
        <div class="document-column">
            <ng-container *ngIf="podDocument">
                <a class="btn btn-i btn-primary pull-right" (click)="download()">
                    <i class="fas fa-file-download"></i>
                </a>
            </ng-container>
        </div>
    </div>

    <div class="ibox-content no-border reject-container">
        <div class="document-column col-md-12">
            <ng-container *ngIf="selectedPod.rejected">
                <strong [i18n]="'pods-validation.document.rejected-by-chep'"></strong>
                <div class="comment text-pre-line"
                     *ngIf="selectedPod.rejectReason && selectedPod.rejectReason !== ''">
                    {{selectedPod.rejectReason}}
                </div>
            </ng-container>

            <ng-container *ngIf="selectedPod.type === PodValidationDeliveryType.MR &&
                                 !selectedPod.rejected &&
                                 selectedPod.state !== PodState.VALIDATED
                                 && selectedPod.mrFinalQuantity">
                <strong [i18n]="'pods-validation.document.mr-final-quantity'"></strong>
                <div class="comment text-pre-line">
                    {{selectedPod.mrFinalQuantity}}
                </div>
            </ng-container>

            <ng-container *ngIf="podWasUploadedToTms()">
                <strong [i18n]="'pods-validation.document.already-uploaded-to-TMS'"></strong>
            </ng-container>
        </div>
    </div>

    <div class="ibox-content no-border reject-container" *ngIf="selectedPod.type === PodValidationDeliveryType.MR &&
                                                                selectedPod.rejected &&
                                                                (selectedPod.mrFinalQuantity ||
                                                                selectedPod.deliveryItems.length)">
        <div class="document-column col-md-9">
            <div class="document-column col-md-9">
                <strong [i18n]="'pods-validation.document.mr-final-quantity'"></strong>
                <div class="comment text-pre-line">
                    {{selectedPod.mrFinalQuantity}}
                </div>
            </div>
        </div>
        <div class="document-column col-md-4"></div>
    </div>

    <div class="document-content ibox-content no-border padding-top-0" *ngIf="podDocument && podDocument.content">
        <ng-container *ngIf="acceptedFileTypes.includes(podDocument.content.type) else notSupported">

            <iframe *ngIf="podDocument.content.type === 'application/pdf'"
                    [src]="podDocument.content | resourceSecureBlob"
                    width="100%"
                    height="100%">
            </iframe>
            <img *ngIf="['image/png', 'image/jpeg'].includes(podDocument.content.type)"
                 [attr.src]="podDocument.content | resourceSecureBlob"
                 class="previewImg">
        </ng-container>

        <ng-template #notSupported>
            <span [i18n]="'pods-validation.document.not-supported'"></span>
        </ng-template>
    </div>
</div>

<div class="ibox" *ngIf="shouldDisplayEmptyPage && selectedPod == null">
    <div class="ibox-title text-center">
        <h2 [i18n]="'pods-validation.document.instructions.title'"></h2>
    </div>

    <div class="ibox-content text-center padding-top-50">
        <div class="raw">
                        <span class="text-bold-20"
                              [i18n]="'pods-validation.document.instructions.drag-n-drop.title'">
                        </span>
        </div>
        <div class="raw">
            <span [i18n]="'pods-validation.document.instructions.drag-n-drop.text'"></span>
        </div>
    </div>

    <div class="ibox-content no-border text-center">
        <div class="raw">
            <span class="text-bold-20" [i18n]="'pods-validation.document.instructions.or'"></span>
        </div>
    </div>

    <div class="ibox-content no-border text-center">
        <div class="raw">
                        <span class="text-bold-20"
                              [i18n]="'pods-validation.document.instructions.upload.title'">
                        </span>
        </div>
        <div class="raw">
            <span [i18n]="'pods-validation.document.instructions.upload.text'"></span>
        </div>
    </div>

    <div class="ibox-content no-border text-center">
        <div class="raw">
            <span [i18n]="'pods-validation.document.instructions.format'"></span>
        </div>
        <div class="raw">
            <span [i18n]="'pods-validation.document.instructions.size'"></span>
        </div>
    </div>

    <div class="ibox-content no-border text-center padding-bottom-50">
        <i class="fas fa-arrow-left text-bold-50"></i>
    </div>
</div>
